// Standard "Pleco-like" colors
export const getToneColor = (tone: number) => {
  switch (tone) {
    case 1:
      return 'text-rose-500' // High/Flat
    case 2:
      return 'text-emerald-600' // Rising
    case 3:
      return 'text-sky-500' // Dipping
    case 4:
      return 'text-violet-600' // Falling
    case 5:
      return 'text-gray-500' // Neutral
    default:
      return 'text-gray-900'
  }
}
